import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { MyOrganisationsPageComponent } from "./my-organisations-page.component";

export const myOrganisationsPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-my-organistions-page", MyOrganisationsPageComponent)
    .atUrl("/my-organisations")
    .withTitle("My organisations")
    .build();
